module.exports = __webpack_public_path__ + "static/media/WebsiteBg01.3743b21f.jpg";